import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faBars } from '@fortawesome/free-solid-svg-icons';
import Avatar from '../shared/Avatar';
import { useEffect, useState } from 'react';
import { getSubscriber } from '../../apiservices/LocalStorageService';
import './TopBar.css';

interface TopBarProps {
  onMenuToggle: () => void;
}

const TopBar: React.FC<TopBarProps> = ({ onMenuToggle }) => {
  const [name, setName] = useState('');

  useEffect(() => {
    const sub = getSubscriber();
    if (sub?.firstName) setName(sub.firstName);
  }, []);

  return (
    <header className="topbar">
      <button
        className="topbar__menu-btn"
        onClick={onMenuToggle}
        aria-label="Toggle menu"
      >
        <FontAwesomeIcon icon={faBars} />
      </button>
      <div className="topbar__greeting">
        <span className="topbar__greeting-sub">Hey, {name || 'there'}! 👋</span>
        <h1 className="topbar__greeting-main">Ready to quiz?</h1>
      </div>
      <div className="topbar__actions">
        <button className="topbar__icon-btn" aria-label="Notifications">
          <FontAwesomeIcon icon={faBell} />
          <span className="topbar__notif-dot" />
        </button>
      </div>
    </header>
  );
};

export default TopBar;
